import React, { useContext } from "react";
import { FiFacebook, FiInstagram, FiLinkedin } from "react-icons/fi";
import { SlGlobe } from "react-icons/sl";
import { ProfileContext } from "../contexts/ProfileContext";
import styled from "styled-components";

export const PageFooter = () => {
  const { worker } = useContext(ProfileContext);

  return (
    <Wrapper className="p-5">
      <div className="footer-top">
        <div className="footer-left">
          <div className="footer-section">
            <h5>COMPANY</h5>
            <div className="footer-links">
              <div className="footer-links-column">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://anyonepray.com/about/crossroads/"
                >
                  About
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://crossroads.ca/terms-of-service/"
                >
                  Terms of Service
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://anyonepray.com/wp-content/uploads/2024/01/Platform-privacy-policy-v2.pdf"
                >
                  Privacy Policy
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://crossroads.ca/cookie-policy/"
                >
                  Cookie Policy
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://crossroads.ca/sms-terms-conditions/"
                >
                  SMS Terms & Conditions
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://crossroads.ca/news/crossroads-updates/"
                >
                  Company Updates
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-middle">
          <div className="contact-section">
            <h5>ACCOUNT MANAGER EMAIL</h5>
            <a href="mailto:sstahl@crossroads.ca">sstahl@crossroads.ca</a>
          </div>

          <div className="contact-section">
            <h5>TECHNICAL SUPPORT EMAIL</h5>
            <a href="mailto:support@anyonepray.com">support@anyonepray.com</a>
          </div>

          <div className="contact-section">
            <h5>CROSSROADS SWITCHBOARD</h5>
            <span className="phone-number">1-905-335-7100</span>
          </div>
        </div>

        <div>
          {worker?.role === "subscriber" && (
            <div className="contact-section">
              <ToolboxLink
                onClick={() =>
                  window.open(
                    "https://drive.google.com/drive/folders/1l-tux9vHLhEJz6SXQ-amiJVFYLtvn8fh?usp=sharing",
                    "_blank"
                  )
                }
              >
                SUBSCRIBER TOOLBOX
              </ToolboxLink>
            </div>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="copyright">
          © {new Date().getFullYear()} Crossroads Christian Communications Inc.
        </div>

        <div className="logo-social-section">
          <CompanyLogo
            src={"https://brass-lynx-1229.twil.io/assets/crossroads_dark.png"}
            alt="Crossroads logo"
          />
          <div className="social-icons">
            <a href="#" aria-label="Facebook">
              <FiFacebook size="22" />
            </a>
            <a href="#" aria-label="Instagram">
              <FiInstagram size="22" />
            </a>
            <a href="#" aria-label="LinkedIn">
              <FiLinkedin size="22" />
            </a>
            <a href="#" aria-label="Website">
              <SlGlobe size="22" />
            </a>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.footer`
  background-color: #00323b;
  padding: 40px 5%;
  color: white;
  font-family: "Futura PT", sans-serif;

  .footer-top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 40px;
  }

  .footer-left,
  .footer-middle,
  .footer-right {
    flex: 1;
    min-width: 250px;
  }

  .footer-section {
    margin-bottom: 20px;
  }

  h5 {
    color: #c2edf6;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    font-family: "Futura PT", sans-serif;
  }

  .footer-links {
    display: flex;
  }

  .footer-links-column {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .footer-links-column *:focus {
    outline: none;
  }

  a {
    color: #2db3c0;
    text-decoration: none;
    font-size: 19px;
    font-weight: 400;
    transition: color 0.2s ease;
    font-family: "Futura PT", sans-serif;

    &:hover {
      color: #c2edf6;
      text-decoration: underline;
    }
  }

  .footer-middle a {
    font-size: 18px; /* ✅ second part */
  }

  .contact-section {
    margin-bottom: 25px;
  }

  .contact-section a {
    display: block;
    margin-top: 5px;
  }

  .phone-number {
    color: #2db3c0;
    font-size: 18px;
    font-weight: 400;
    font-family: "Futura PT", sans-serif;
  }

  .company-name {
    color: #c2edf6;
    font-size: 14px;
    margin-top: 5px;
  }

  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: end;
    flex-wrap: wrap;
    gap: 20px;
  }

  .copyright {
    color: #c2edf6;
    font-size: 14px;
    font-weight: 400;
    font-family: "Space Grotesk", sans-serif;
  }

  .logo-social-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .social-icons {
    display: flex;
    gap: 20px;
    padding-right: 20px;

    a {
      color: white;
      opacity: 0.8;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 1;
        color: #2db3c0;
      }
    }
  }

  @media (max-width: 768px) {
    .footer-top {
      flex-direction: column;
      gap: 30px;
    }

    .footer-bottom {
      flex-direction: column;
      align-items: flex-start;
      gap: 30px;
    }

    .logo-social-section {
      align-items: flex-start;
    }
  }
`;

const CompanyLogo = styled.img`
  width: 400px;
  height: auto;
  filter: brightness(0) invert(1);
  opacity: 0.9;
`;

const ToolboxLink = styled.button`
  background-color: transparent;
  border: 2px solid #ff7234;
  color: #adcfd4;
  padding: 8px 16px;
  border-radius: 30px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.3s ease;
  margin-top: 5px;
  letter-spacing: 0.15em;

  &:hover {
    opacity: 1;
    background-color: rgba(255, 114, 52, 0.1);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 114, 52, 0.5);
  }
`;
